function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/**
 * Slider v1.1.1
 *
 * Copyright brandung GmbH & Co.KG
 *
 * Date: 2019-12-17
 * MIT License (MIT)
 *
 * @see http://idangero.us/swiper/api/
 */
import { Swiper, Navigation, Pagination, Autoplay, Lazy } from 'swiper/js/swiper.esm.js';
Swiper.use([Navigation, Pagination, Lazy, Autoplay]);
var _ = {
  defaults: {
    componentSelector: '.customer-module--swiper',
    classes: {}
  }
};
var o = _.defaults;

var initCustomerBar = function initCustomerBar() {
  var slideCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 4;
  var swiper = new Swiper(".customer-module--swiper", {
    spaceBetween: 20,
    slidesPerView: 4,
    slidesPerGroup: 1,
    loop: slideCount <= 4 ? false : true,
    watchOverflow: slideCount <= 4,
    centeredSlides: false,
    autoplay: slideCount <= 4 ? false : {
      delay: 2000,
      disableOnInteraction: false
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        slidesPerGroup: 1
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 1,
        slidesPerGroup: 1
      },
      580: {
        slidesPerView: 2,
        spaceBetween: 20,
        slidesPerGroup: 1
      },
      // when window width is >= 640px
      840: {
        slidesPerView: 2,
        spaceBetween: 20,
        slidesPerGroup: 1
      },
      1020: {
        slidesPerView: 2,
        spaceBetween: 20,
        slidesPerGroup: 1
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 20,
        slidesPerGroup: 1
      }
    },
    on: {
      init: function init() {
        this.el.classList.add('is-autoplay-init');
        setTimeout(function () {
          swiper.update();
          swiper.autoplay.start();
        }, 3100);
      }
    }
  });
};

export function init() {
  return _init.apply(this, arguments);
}

function _init() {
  _init = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var slides, slideCount;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // If there's atleast one swiper - go ahead an init
            if (document.querySelector(o.componentSelector)) {
              slides = document.querySelector('.customer-module--swiper');
              slideCount = slides.querySelectorAll('.swiper-slide:not(swiper-slide-duplicate)').length || 4;
              console.log('customer-module init');
              initCustomerBar(slideCount);
            }

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _init.apply(this, arguments);
}